import React, { ChangeEvent } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AgentFormState } from "../../../types/agentTypes";
import { FieldColumn, FieldRow } from "../styles";

type BelarusCitizensSectionProps = {
  formData: AgentFormState;
  isCreate: boolean;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => void;
};

const BelarusCitizensSection = ({
  formData,
  isCreate,
  onChange,
}: BelarusCitizensSectionProps) => {
  const { t } = useTranslation();

  return (
    <FieldRow>
      <FieldColumn>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!formData?.include_belarus_citizens}
              onChange={onChange}
              name="include_belarus_citizens"
            />
          }
          label={t("createAgent.belarusCitizens.includeInCalculation")}
          disabled={!isCreate}
        />
      </FieldColumn>
    </FieldRow>
  );
};

export default BelarusCitizensSection;
